import {
  Flex,
  Form,
  FormControl,
  FormLabel,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { CurrentlySelectedZipCityState } from '../ForYouContent'
import { GeoArea, MarketSource } from '../../../api/gqlaxy/gql/generated/graphql'
import { useGetMarketInterest } from '../../../hooks/gallery/useGetMarketInterest'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types/rootState'

const MSG = defineMessages({
  switchToAnotherMarket: {
    id: 'MarketSwitchDropdown',
    defaultMessage: 'Switch to another market'
  },
  addNewMarket: {
    id: 'MarketSwitchDropdown.addNewMarket',
    defaultMessage: 'Add new'
  },
  addedByYou: {
    id: 'MarketSwitchDropdown.addedByYou',
    defaultMessage: 'added by you'
  },
  loOfficeZipcode: {
    id: 'MarketSwitchDropdown.loOfficeZipcode',
    defaultMessage: '{loName} ZIP'
  },
  yourCurrentHomeZipcode: {
    id: 'MarketSwitchDropdown.yourCurrentHomeZipcode',
    defaultMessage: 'your current home ZIP'
  }
})

interface MarketSwitchDropdownProps {
  onLocationChange: (zipCityState: CurrentlySelectedZipCityState) => void
  setShowGooglePlaceSelector: (shouldShow: boolean) => void
  favoriteMarkets?: Record<string, GeoArea>
  selectedZip?: string
}

export const MarketSwitchDropdown = ({
  selectedZip,
  onLocationChange,
  setShowGooglePlaceSelector
}: MarketSwitchDropdownProps) => {
  const intl = useIntl()

  const { data: marketsInterest } = useGetMarketInterest({
    enabled: true
  })

  const [customerProfile] = useSelector((state: RootState) => [state.customerProfile])

  const allMarkets = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets.reduce(
        (acc, market) => {
          acc[`${market.geoArea.zipCode}`] = market.geoArea
          return acc
        },
        {} as Record<string, GeoArea>
      )
    }
    return {} as Record<string, GeoArea>
  }, [marketsInterest?.markets])

  const selectedMarket = allMarkets[selectedZip]

  const getZipcodeSource = (zipcode: string): string => {
    const marketInterest = marketsInterest?.markets?.find(market => market.geoArea.zipCode === zipcode)
    if (marketInterest?.source === MarketSource.MarketInterest) {
      return intl.formatMessage(MSG.addedByYou)
    }
    if (marketInterest?.source === MarketSource.CustomerOffice) {
      return intl.formatMessage(MSG.loOfficeZipcode, { loName: customerProfile?.data?.firstName })
    }
    if (marketInterest?.source === MarketSource.Prequal) {
      return intl.formatMessage(MSG.yourCurrentHomeZipcode)
    }

    return ''
  }

  return (
    <Form onSubmit={data => alert(data)} width={['100%', '100%', '100%', 'auto']}>
      <FormControl>
        <FormLabel srOnly>{intl.formatMessage(MSG.switchToAnotherMarket)}</FormLabel>
        <Menu
          tracking={{
            ui_context: 'For you page',
            descriptor: 'Market select menu',
            guid: 'fpu69wAc4aURzoDjLdTPtd'
          }}
        >
          <MenuButton width='100%'>{`${selectedMarket?.zipCode} ${getZipcodeSource(selectedMarket?.zipCode) ? `- ${getZipcodeSource(selectedMarket?.zipCode)}` : ''
            }`}</MenuButton>
          <MenuList zIndex={2}>
            {Object.values(allMarkets).map((market: GeoArea, i) => (
              <MenuItem
                key={i}
                onClick={() =>
                  onLocationChange({
                    zipcode: market.zipCode,
                    city: market.city,
                    stateAbbreviation: market.stateAbbreviation
                  })
                }
                as={Flex}
                alignItems='center'
                gap={2}
                value={market.zipCode}
              >
                <Flex width='10%'>{market.zipCode === selectedZip && <Icon name='check' fontSize='xs' />}</Flex>
                <Flex width='90%' textAlign='left'>
                  {`${market.zipCode} ${getZipcodeSource(market.zipCode) ? `- ${getZipcodeSource(market.zipCode)}` : ''
                    }`}
                </Flex>
              </MenuItem>
            ))}
            <MenuItem paddingLeft={10} onClick={() => setShowGooglePlaceSelector(true)}>
              {intl.formatMessage(MSG.addNewMarket)}
            </MenuItem>
          </MenuList>
        </Menu>
      </FormControl>
    </Form>
  )
}
